const Navbar = require('../Navbar');
const NavbarItemDetailed = require('./NavbarItemDetailed');

class NavbarDetailed extends Navbar {
  constructor(container) {
    super(container);
    this.$megaRow = jQuery(container).find('.mad-navbar__row--mega');
    this.$pageInfoContainer = jQuery(container).find('.mad-navbar-page-info__container'); // Reference to page info container
    this.NavbarItemClass = NavbarItemDetailed;
    this.init();
  }

  initNavItems() {
    jQuery('.mad-navbar-page-info').hide();
    this.$container.addClass('mad-navbar__container--smooth');

    super.initNavItems();
    for (const navItem of this.navItems) {
      navItem.hideAllNavItems = this.hideAllNavItems.bind(this);
      navItem.setMegaRow = this.setMegaRow.bind(this);

      if (navItem.hasSubmenu) {
        navItem.initSubmenuTitle();
        this.initNavItemSubmenuItems(navItem);
      }
    }

    this.hoverTimeout = null; // Declare hoverTimeout as a member variable

    for (const navItem of this.navItems) {
      const navItemContainer = navItem.$container;

      jQuery(navItemContainer).on('mouseenter', (event) => {
        const anySubmenuActive = this.navItems.some(item => item.isActive && item.hasSubmenu);
        let delay;
        if (anySubmenuActive && navItem.hasSubmenu) delay = 100;
        else if (anySubmenuActive && !navItem.hasSubmenu) delay = 250;
        else delay = 170;

        this.hoverTimeout = setTimeout(() => {
          if (navItem.$submenu.length > 0) {
            this.hideAllNavItems(navItem, true);

            navItem.show(function () {
              this.setMegaRow(navItem);
            }.bind(this));
          } else {
            this.hideAllNavItems();
            this.resetMegaRow();
          }
        }, delay);
      });

      // Clear the timeout if the mouse leaves before the delay finishes
      jQuery(navItemContainer).on('mouseleave', () => {
        clearTimeout(this.hoverTimeout); // Cancel the hover action if mouse leaves early
      });
    }
  }
  
  

  initNavItemSubmenuItems(navItem) {
    for (const $submenuNavItem of jQuery(navItem.$submenu).find('.mad-navbar__submenu .mad-navbar__submenu-item')) {
      const submenuNavItem = new NavbarItemDetailed(jQuery($submenuNavItem))
      submenuNavItem.hasParent = true;
      submenuNavItem.hideAllNavItems = this.hideAllNavItems.bind(this);
      submenuNavItem.setMegaRow = this.setMegaRow.bind(this);

      navItem.$submenuNavItems.push(submenuNavItem);
      submenuNavItem.initSubmenuEvents(navItem.$submenuNavItems);
      if (submenuNavItem.hasSubmenu) {
        this.initNavItemSubmenuItems(submenuNavItem);
      }
    }
  }

  setMegaRow() {
    setTimeout(() => {
      let megaWrapper = this.$megaRow.find('.mad-navbar__mega-wrapper');
      let targetHeight = megaWrapper.outerHeight();
      let currentHeight = parseFloat(this.$megaRow.css('height')) || 0;

      if (currentHeight > 0 && Math.abs(targetHeight - currentHeight) < 8) {
        this.$megaRow.css('height', targetHeight + 'px');
        return;
      }

      gsap.killTweensOf(this.$megaRow);
      gsap.to(this.$megaRow, {
        height: targetHeight,
        duration: 0.3,
        delay: currentHeight === 0 ? 0.08 : 0,
        ease: 'power2.inOut',
        onComplete: () => {
          this.$megaRow.css('height', targetHeight + 'px');
        }
      });
    }, 50);
  }

  resetMegaRow() {
    this.hideAllNavItems();
    gsap.to(this.$megaRow, {
      height: 0,
      duration: 0.3,
      ease: 'power2.inOut'
    });
  }

  hideAllNavItems(exception = null, hideFirstLevel=false) {
    for (const navItem of this.navItems) {
      if (navItem !== exception) {
        navItem.hide(exception, hideFirstLevel);
      }
    }
  }

  initContainer() {
    this.$parentContainer.on('mouseleave', () => {
      this.resetTimeout = setTimeout(() => {
        this.resetMegaRow();
      }, 150);
    });

    this.$parentContainer.on('mouseenter', () => {
      if (this.resetTimeout) {
        clearTimeout(this.resetTimeout);
        this.resetTimeout = null;
      }
    });
  }
}

module.exports = NavbarDetailed;
